import { Query } from "@repo/rq-api-public";
import { useAtomValue } from "jotai";
import { listingGuidAtom, campaignCodeAtom, campaignValidationAtom, passengersAtom, selectedPackageAtom, selectedDateAtom, currentStepAtom } from "../components/widget/store";

export const useListingQuery = () => {
  const listingGuid = useAtomValue(listingGuidAtom);
  const query = Query.useListingsGuidGETQuery(listingGuid!, {
    enabled: !!listingGuid,
  });
  return query;
};

export const usePricingCalculateQuery = (options?: {
  promoCode?: string;
  promoCodeStartDateTime?: Date;
  enabled?: boolean;
}) => {
  const selectedPackage = useAtomValue(selectedPackageAtom);
  const passengers = useAtomValue(passengersAtom);
  const campaignCode = useAtomValue(campaignCodeAtom);
  const campaignValidation = useAtomValue(campaignValidationAtom);
  const selectedDate = useAtomValue(selectedDateAtom);
  const currentStep = useAtomValue(currentStepAtom);

  // Campaign codes and promo codes are mutually exclusive
  // Only use campaign if it's present AND valid AND we're in step 3 or later
  const shouldUseCampaign = !!campaignCode && campaignValidation.isValid === true && currentStep >= 3;
  const shouldUsePromo = !shouldUseCampaign && !!options?.promoCode;

  return Query.usePricingsCalculateGETQuery({
    pricingGuid: selectedPackage?.pricingGuid || undefined,
    passengers,
    // Only send promo code params if no valid campaign code is present
    promoCodeRequest_PromoCode: shouldUsePromo ? options?.promoCode : undefined,
    promoCodeRequest_StartDateTime: shouldUsePromo ? options?.promoCodeStartDateTime : undefined,
    // Only send campaign code params if campaign code is valid AND we're in step 3+
    campaignCodeRequest_Code: shouldUseCampaign ? (campaignCode ?? undefined) : undefined,
    campaignCodeRequest_StartDateTime: shouldUseCampaign ? selectedDate : undefined,
  }, {
    enabled: !!selectedPackage?.pricingGuid && (options?.enabled ?? true),
  });
};
